import { Component, effect } from '@angular/core';
import { FormControl, ReactiveFormsModule,} from '@angular/forms';

import { TrimmedSession } from '../../../shared/models/session.model';
import { CouponFormat } from '../../../shared/models/couponFormat.model';
import { Plan } from '../../../shared/models/plan.model';
import { PromoService } from '../../../shared/promo.service';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';

@Component({
  selector: 'app-dynamic-payment-component-coupon-form',

  template: `
    @if(hasValidCoupon){
      <div class="coupon-applied">
        <span class="coupon-applied-message" aria-label="Applied promo code">
          <img src="assets/Icons/check-circle.svg" alt="" class="coupon-applied-icon">
          {{this.coupon.message}}
        </span>
        <button type="button" aria-label="Remove promo code" class="coupon-remove-button" (click)="removeCoupon()">Remove</button>
      </div>
    } @else {
      <div appearance="outline" floatLabel="always">
        <div class="input-group">
          <input aria-label="sets coupon code with text input" matInput type="text" class="form-control d-inline-block" name="coupon"
            [formControl]="couponControl" placeholder="Enter promo code" (keydown.enter)="checkCouponCode()">
          <button aria-label="Apply coupon" class="btn d-inline-block"
            [class.btn-outline-secondary]="!hasCouponInput"
            [class.apply-button-active]="hasCouponInput"
            [disabled]="!hasCouponInput"
            matSuffix mat-icon-button (click)="checkCouponCode()">Apply</button>
        </div>
      </div>
      @if(couponErrorFlag){
        <p class="ps-2plus coupon-highlight-fail">*Not a Valid coupon</p>
      }
    }
  `,
  styleUrls: ['./dynamic-payment-component-coupon-form.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
})
export class DynamicPaymentComponentCouponFormComponent {

  couponControl = new FormControl('');

  //need Plan and generic session details
  couponString : string = '';

  get plan(): Plan {
    return this.directSessionLogic.planSelectedSignal();
  }
  get coupon(): CouponFormat {
    return this.promoService.couponSignal();
  }
  get couponErrorFlag(): boolean {
    return this.promoService.couponErrorFlagSignal();
  }
  get trimmedSession(): TrimmedSession {
    return this.directSessionLogic.trimmedSessionSignal();
  }
  get hasCouponInput(): boolean {
    return !!this.couponControl.value?.trim();
  }
  get hasValidCoupon(): boolean {
    return this.promoService.isCouponFormat(this.coupon);
  }

  constructor(
    public directSessionLogic: DirectSessionLogicService,
    public promoService: PromoService,
  ){

    effect(() => {
      this.couponString = this.promoService.couponInputSignal();
      this.couponControl.setValue(this.couponString);
    });

    //if this session has a coupon code entered from session, set the coupon control to that value
    if(this.directSessionLogic.planSelectedSignal() !== undefined && this.promoService.couponInputSignal() !== "") {
      this.resetFromCoupon();
    }
  }


  async checkCouponCode(){

    let currentCode = this.couponControl.value ?? "";
    if(currentCode != null || currentCode != "" || currentCode != undefined){
      this.promoService.updateCouponInputSignal(currentCode);
      let plan = this.directSessionLogic.planSelectedSignal();
      await this.promoService.validateCouponInputSignal(plan);
    }
    this.directSessionLogic.recalculateTotalCostInSessionSignal();
  }

  isCouponFormat( obj: any): obj is CouponFormat{
    return obj && typeof obj.message === 'string' && obj.message.length > 0;
  }

  removeCoupon(){
    this.promoService.clearCoupon();
    this.couponControl.setValue('');
    this.directSessionLogic.recalculateTotalCostInSessionSignal();
  }

  resetFromCoupon(){
    if( this.couponString !== '' && this.coupon?.code != undefined ) {
      this.couponControl.setValue(this.coupon.code); //value from coupon signal
    }
    else if(this.couponString !== ''){
      this.couponControl.setValue(this.promoService.couponInputSignal()); //value from couponCode signal
    }
    this.checkCouponCode();
    this.directSessionLogic.recalculateTotalCostInSessionSignal();
  }

}
